import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';


@Component({
  selector: 'co-popover-staff-sign-out',
  templateUrl: 'co-popover-staff-sign-out.html'
})
export class CoPopoverStaffSignOutComponent {

  constructor(private viewCtrl: ViewController, private navParams: NavParams) {}

  staffSignOut() {
    this.viewCtrl.dismiss(true);
  }

}



// WEBPACK FOOTER //
// ./src/components/co-popover-staff-sign-out/co-popover-staff-sign-out.ts